import styled from 'styled-components';
import { breakpoints, radius, spacing } from '@naf/theme';
import { Button } from '@naf/button';
import { Text } from '@naf/text';
import { GridCol } from '@naf/grid';

export const ButtonContainer = styled.div`
  display: flex;
  text-align: center;
  margin-top: ${spacing.space40};
  margin-bottom: ${spacing.space48};
  gap: ${spacing.space24};

  @media (max-width: ${breakpoints.l}) {
    flex-direction: column;
  }

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: ${spacing.space40};

    button,
    a {
      width: 100%;
    }
  }
`;

export const WideButton = styled(Button)`
  min-width: 212px;
  height: ${spacing.space48};
  border-radius: ${radius.s};
  gap: ${spacing.space12};
  padding: ${spacing.space16} ${spacing.space24};
`;

export const HeaderText = styled(Text)`
  margin-bottom: -${spacing.space24};
`;

export const ImageGridColumn = styled(GridCol)`
  margin-top: ${spacing.space24};
  width: auto;
  height: 313px;
`;
